import api from "@/lib/api";

/** Log a checkpoint T&C acceptance for the current logged-in user.
 *  Used at upload (seller) / purchase (buyer) / accept-job (vendor) /
 *  confirm-quote (buyer) — a fresh, dated consent record every time.
 *  Silently swallows failures so a network hiccup doesn't block the action;
 *  legal enforceability comes from the signup / re-acceptance records. */
export async function logTermsCheckpoint({ role, event, contextId, checkboxes = [] }) {
  try {
    const { data: doc } = await api.get(`/terms/${role}/current`);
    await api.post("/terms/accept", {
      role,
      version: doc.version,
      checkboxes,
      event,
      context_id: contextId || null,
    });
    return true;
  } catch (e) {
    console.warn("checkpoint T&C log failed:", e?.response?.data || e?.message);
    return false;
  }
}
